import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { cn } from '@/shared/utilities/cn';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';

interface AppShellProps {
  children?: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-slate-900">
      {/* Desktop Sidebar */}
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        className="hidden lg:flex"
      />

      {/* Mobile Sidebar */}
      <MobileNav open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content area */}
      <div
        className={cn(
          'flex flex-1 flex-col transition-all duration-200',
          sidebarCollapsed ? 'lg:ms-[64px]' : 'lg:ms-[256px]'
        )}
      >
        {/* Header */}
        <Header
          onMenuClick={() => setSidebarOpen(true)}
          className="sticky top-0 z-40"
        />

        {/* Page content */}
        <main className="flex-1 p-4 md:p-6">
          {children || <Outlet />}
        </main>

        {/* Footer */}
        <footer className="border-t border-slate-200 px-4 py-3 text-center text-xs text-slate-500 dark:border-slate-800 dark:text-slate-400">
          <span>MIP Platform v{__APP_VERSION__}</span>
          <span className="mx-2">|</span>
          <span>Built: {new Date(__BUILD_TIME__).toLocaleDateString()}</span>
        </footer>
      </div>
    </div>
  );
}

// Declare global build-time constants
declare const __APP_VERSION__: string;
declare const __BUILD_TIME__: string;
